<template>
  <!-- content start -->
  <div class="content">
    <QuizHeader/>
    <div style="height: 200px;" :style="{background: 'var(--bg-color)'}"></div>
    <div class="" style="filter: drop-shadow(0 2px 5px rgba(0,0,0,.16)); margin-right: 15px; margin-left: 15px; margin-top: -140px">
      <div class="history-section common-block" v-if="historyData.length>0">
        <div
            v-for="(item, index) in historyData"
            :class="['live-quiz history-block']"
            v-on:click="showLeaderboard(item)"
        >
          <div class="date">
            <p><span>{{ formatISODateString(item.created_at)[1] }} {{ formatISODateString(item.created_at)[2] }}</span> {{ formatISODateString(item.created_at)[0] }}</p>
          </div>
          <div class="detail" style="text-align: left;">
            <p>{{item.title}}</p>
            <span style="color: #909090; font-size: 12px;">{{item.start_time}} - {{item.end_time}}</span>
          </div>
          <div v-if="item.is_live" class="live">
            Live
          </div>
        </div>
      </div>

      <div v-if="historyData.length===0" class="height-90 border-radius-5 align-ver center-hor bg-light">
        <div style="display: flex; justify-content: center; align-items: center; width: 100%">
          <img src="@/assets/no-data.svg" class="w20" style="width: 20%;">
        </div>
        <div class="font-bold">Player not found</div>
      </div>
    </div>

    <div id="toast" class="font-bold pos-fixed pos-center-hor pull-down" style="width: 80%;
        padding: 5px; border-radius: 10px; background: rgba(0, 0, 0, 0.5);
        margin-bottom: 70px; color: white; display: none; z-index: 999;
        position: fixed;bottom: 0px;"></div>
  </div>
  <!-- content end -->
</template>

<script>
// import Tasks from '../components/Tasks'
import QuizHeader from '@/components/quiz-header'
import axios from "axios"
export default {
  name: 'quiz-history',
  components: {
    QuizHeader
  },
  data: () => ({
    historyData: []
  }),
  computed: {},
  methods: {
    showLeaderboard(item) {
      if (item.is_live) {
        document.getElementById("toast").innerHTML = "Leaderboard will be shown after the quiz ends.";
        document.getElementById("toast").style.display = 'block';
        setTimeout(function() {
          document.getElementById("toast").style.display = 'none';
        }, 2000)
      } else {
        this.$store.state.quizDetailsTitle = item.title;
        this.$router.push({name: 'leadboard', params: {id: item.id, title: item.title}})
      }
    },
    formatISODateString(dateStr) {
      var date = new Date(dateStr);
      var year = date.getFullYear();
      var month = date.toLocaleString('default', { month: 'short' });
      var dt = date.getDate();

      if (dt < 10) {
        dt = '0' + dt;
      }

      return [dt, month, year];
    },
    fetchQuizHistory() {
      var self = this;
      var url = self.$store.getters.flyyDomain + '/v1/quiz_history';
      var headers = self.$store.getters.headers;
      axios.get(url, {
        headers: headers,
      }).then((resp) => {
        if(resp.status == 200) {
          var data = resp.data;
          // console.log(data)
          self.historyData = data.tournaments
        } else {
          console.log("Error fetching the Quiz list");
        }
      })
    }
  },
  created() {
    // this.$emit('handleHideFooter');
    this.fetchQuizHistory();
    this.$store.state.quizDetailsTitle = "Leaderboard"
  },
  mounted() {
    this.$store.state.showQuizHistoryMenu = false;
  }
}
</script>

<style scoped>
  @import '../assets/quiz-styles/quiz-styles.css';
  @import '../assets/quiz-styles/bootstrap.css';
  @import '../assets/fonts/quiz-fonts/fonts.css';
</style>



// WEBPACK FOOTER //
// src/screens/quiz-history.vue